import './BlockTitle.css';

function BlockTitle(props) {
 
  const blockstyle = {
    fontSize: props.fontSize ? props.fontSize : "25pt",
    fontWeight: props.fontWeight ? props.fontWeight : "bold"
  };

  return (
    <div id="BlockTitle" style={blockstyle}>
      {props.children}
    </div>

  );
}

export default BlockTitle;
